import { gql, TypedDocumentNode } from "@apollo/client";

import { Template, TemplateCompatibleVersionsArgs, QueryTemplateArgs } from "types/generated";

type GetCompatibleVersionsForUpdateData = {
  template: Pick<Template, "compatibleVersions">;
};

type GetCompatibleVersionsVariables = QueryTemplateArgs & TemplateCompatibleVersionsArgs;

export const GET_COMPATIBLE_VERSIONS_FOR_UPDATE: TypedDocumentNode<
  GetCompatibleVersionsForUpdateData,
  GetCompatibleVersionsVariables
> = gql`
  query GetCompatibleVersionsForUpdate($id: ID!, $versionId: ID!) {
    template(id: $id) {
      compatibleVersions(versionId: $versionId) {
        id
        version
        state
        instructions
        deprecatedAt
        deprecationNote
        space {
          id
          name
          accessLevel
        }
        inputs {
          id
          name
          default
          description
          options
          type
          validations {
            greaterThan
            greaterThanOrEqual
            lengthEqual
            lessThan
            lessThanOrEqual
            maxLength
            minLength
            notEqual
            pattern
            required
            step
          }
        }
      }
    }
  }
`;
